import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  formLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '280px',
    fontWeight: 600
  },

  formControl: {
    gap: 2
  },

  formContent: {
    gap: '16px',
    display: 'grid'
  },
  footerFormContent: {
    display: 'grid'
  },

  textFieldControlLabel: {
    margin: 0,
    alignItems: 'normal',
    '& .MuiInputBase-multiline': {
      width: '100%'
    },
    '& .cds-textFieldLabelWithCounter': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    '& .cds-textFieldCounter': {
      color: capitalDesignTokens.foundations.colors.gray700
    }
  },

  typographyBase: {
    paddingBottom: 0
  },
  tooltipIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
  },

  typographyCounter: {
    paddingBottom: 0,
    marginLeft: 'auto'
  },

  formLabelLegend: {
    paddingBottom: 0,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    color: capitalDesignTokens.foundations.colors.gray900
  },

  formControlLabelCheckbox: {
    paddingLeft: '8px'
  },

  formControlCheckbox: {
    marginLeft: 0
  },

  numberFormattingFieldset: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },

  filtersFormControl: {
    display: 'flex'
  },

  maxColumnWidthLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  tableFormattingColumnsLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  tableFormattingColumnsSettings: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 1,
    rowGap: 2,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%'
  },

  tableFormattingColumnsPerPageField: {
    width: '100%',
    minWidth: 0,
    flex: '1 1 auto',
    maxWidth: '100%'
  },

  tableLinesFormattingSettings: {
    display: 'flex',
    flexDirection: 'column'
  },

  tableFormattingNumberInput: {
    flex: '1 1 280px',
    minWidth: '280px',
    maxWidth: '100%',
    '& input[type=number]': {
      MozAppearance: 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0
    }
  }
});
